var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCamera = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14,5 L17,5 C17.9632045,5 19,6.0028 19,7 L19,15 C19,15.9972 17.9632045,17 17,17 L4,17 C3.03679545,17 2,15.9972 2,15 L2,7 C2,6.0028 3.03679545,5 4,5 L7,5 L8,3 L13,3 L14,5 Z M10.5,15 C12.4329966,15 14,13.4329966 14,11.5 C14,9.56700338 12.4329966,8 10.5,8 C8.56700338,8 7,9.56700338 7,11.5 C7,13.4329966 8.56700338,15 10.5,15 Z M16,9 C16.5522847,9 17,8.55228475 17,8 C17,7.44771525 16.5522847,7 16,7 C15.4477153,7 15,7.44771525 15,8 C15,8.55228475 15.4477153,9 16,9 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10,13.9499909 C8.85887984,13.7183558 8,12.709479 8,11.5 C8,10.290521 8.85887984,9.28164422 10,9.05000906 L10,10.0853529 C9.41740381,10.2912711 9,10.8468906 9,11.5 C9,12.1531094 9.41740381,12.7087289 10,12.9146471 L10,13.9499909 Z"
})))));
export default SvgCamera;